import { Col, Container, Row, View } from "@amzn/stencil-react-components/layout";
import { useBreakpoints } from "@amzn/stencil-react-components/responsive";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { OrderTrackingHeader } from "@/pages/OrderTracking/components/OrderTrackingHeader/order-tracking-header";
import { OrderProgressSteps } from "@/pages/OrderTracking/components/OrderProgressSteps/order-progress-steps";
import { OrderedItems } from "@/pages/OrderTracking/components/OrderedItems/ordered-items";
import { OrderSummaryPanel } from "@/pages/OrderTracking/components/OrderSummaryPanel/order-summary-panel";
import type { OrderTrackingView } from "@/pages/OrderTracking/order-tracking.types";

const COLUMNS_DIRECTION_BY_BREAKPOINT = {
  s: { flexDirection: "column" },
  m: { flexDirection: "column" },
  default: { flexDirection: "row" },
};

export interface OrderTrackingLayoutProps {
  view: OrderTrackingView;
}

export const OrderTrackingLayout: FC<OrderTrackingLayoutProps> = ({ view }) => {
  const { props: columnsDirection } = useBreakpoints({ propsMap: COLUMNS_DIRECTION_BY_BREAKPOINT });

  return (
    <Container maxWidth="100%" paddingHorizontal="S700" paddingTop="S300" paddingBottom="S500">
      <Col gridGap="S400" width="100%">
        <OrderTrackingHeader orderNumber={view.orderNumber} />
        <Row gridGap="S400" width="100%" alignItems="flex-start" {...columnsDirection}>
          <Col gridGap="S300" flex={2} width="100%">
            {view.steps && <OrderProgressSteps steps={view.steps} />}
            <OrderedItems item={view.item} />
          </Col>
          <View flex={1} width="100%">
            <aside aria-label={getString("orderTracking.summaryLabel")}>
              <OrderSummaryPanel orderNumber={view.orderNumber} rows={view.summaryRows} />
            </aside>
          </View>
        </Row>
      </Col>
    </Container>
  );
};
